import { getDateOnlyString } from '../date/get-date-only-string';

/**
 * buildDatedFileName
 *
 * Arma el nombre de un archivo descargado anteponiéndole la fecha en formato
 * año-mes-día: `2026-08-06 Reporte producción.xlsx`.
 *
 * La fecha va adelante y en ese formato para que los archivos que el usuario
 * acumula en su carpeta de descargas queden ordenados cronológicamente al
 * ordenar por nombre — con `6-8-2026` no pasa.
 *
 * Existe como función compartida porque la regla estaba copiada en cada
 * pantalla que exporta, y cada copia la implementaba distinto (una llegaba a
 * mezclar `getDate()`/`getMonth()` locales con `getUTCFullYear()`, así que el
 * 31 de diciembre bajaba con el año equivocado).
 */
export function buildDatedFileName(
  baseName: string,
  extension: string,
  date: Date = new Date()
): string {
  return `${getDateOnlyString(date)} ${baseName}.${extension}`;
}
